import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Part } from '../../products/part';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PersonLoginService } from '../../services/person-login-service';
import { RoleName } from '../../person/person-login';

@Component({
  selector: 'app-parts-serialnumber-dialog',
  templateUrl: './parts-serialnumber-dialog.component.html',
  styleUrls: ['./parts-serialnumber-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, MatButtonModule, MatDialogModule, MatProgressSpinnerModule],
})
export class PartsSerialNumberDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<PartsSerialNumberDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);
  private personLoginService = inject(PersonLoginService);
  errorMessage!: string;
  isBusy!: boolean;
  parts: Part[];
  filteredParts!: Part[];

  constructor() {
    this.parts = this.data.parts as Part[];
  }

  private isBypassUser(): boolean {
    return this.personLoginService.hasRole(RoleName.IECIT) || this.personLoginService.hasRole(RoleName.PartsEngineer);
  }

  ngOnInit(): void {
    this.filteredParts = this.parts.filter((p) => p.requireSerialNumber && +p.quantity === 1);
  }

  public saveAndClose(): void {
    this.isBusy = true;
    if (this.isBypassUser() || this.serialDataIsValid()) {
      this.dialogRef.close(this.parts);
    } else {
      this.isBusy = false;
      this.errorMessage = 'Please enter a valid serial number';
    }
  }

  private serialDataIsValid(): boolean {
    const regex = /^(?:\d{2}-\d{5,6}|\d{6}-\d{1,3}-\d{1,3}|\d{2}U\d{8})$/;
    return this.filteredParts.every((part) => regex.test(part.serialNumber));
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
